module.exports = __webpack_public_path__ + "9994495c670fd688bae468636a10c75e.svg";